// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".variable-container[data-v-2c09b537] {\n  display: inline-block;\n  vertical-align: top;\n  background: #f2f2f2;\n  padding: 20px;\n  border-radius: 6px;\n}\n.variable-container .btn-container[data-v-2c09b537] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.variable-container .btn-container .tag-btn[data-v-2c09b537] {\n  height: 28px;\n  line-height: 26px;\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
